'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                  * Tencent is pleased to support the open source community by making SPA UI available.
                                                                                                                                                                                                                                                                  * Copyright (C) 2019, a Tencent company. All rights reserved.
                                                                                                                                                                                                                                                                  */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _spauiUtils = require('@tencent/spaui-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    var _props$type = props.type,
        type = _props$type === undefined ? '' : _props$type,
        show = props.show,
        stroke = props.stroke,
        circleSize = props.circleSize,
        display = props.display,
        devProps = props.devProps;
    // 统一获取全局样式

    var getGlobalProps = function getGlobalProps() {
        var customProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _spauiUtils.globalProps)(props, customProps, devProps[0], devProps[1]);
    };
    var result = null,
        loaderStyle = {},
        svgLoading = null;

    if (type === 'page') {
        // 整个页面的loading
        if (show) {
            result = _react2.default.createElement(
                'div',
                getGlobalProps({
                    className: 'module-loading spaui-loading loading-new'
                }),
                _react2.default.createElement(
                    'div',
                    { className: 'spin-loader' },
                    _react2.default.createElement(
                        'svg',
                        { className: 'spin-circular', viewBox: '25 25 50 50' },
                        _react2.default.createElement('circle', { className: 'spin-path', cx: '50', cy: '50', r: '20', fill: 'none' })
                    )
                )
            );
        }
    } else if (type === 'svg') {
        // svg的loading
        svgLoading = _react2.default.createElement(
            'svg',
            { className: 'spin-circular', viewBox: '25 25 50 50' },
            _react2.default.createElement('circle', { className: 'spin-path', style: {
                    stroke: stroke
                }, cx: '50', cy: '50', r: '20', fill: 'none' })
        );
        // svg的loading
        if (typeof show === 'undefined' || show) {
            if (display === 'inline-block' || display === 'center') {
                // 居中的时候要设置下边距
                if (display === 'center') {
                    loaderStyle = {
                        marginTop: -circleSize / 2,
                        marginLeft: -circleSize / 2
                    };
                }
                result = _react2.default.createElement(
                    'div',
                    getGlobalProps({
                        className: 'spin-loader spaui-loading-spin-loader-' + display,
                        style: _extends({
                            width: circleSize + 'px'
                        }, loaderStyle)
                    }),
                    svgLoading
                );
            } else {
                result = _react2.default.createElement(
                    'div',
                    getGlobalProps({
                        className: 'spaui-loading loading-new'
                    }),
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'spin-loader',
                            style: {
                                width: circleSize + 'px'
                            }
                        },
                        svgLoading
                    )
                );
            }
        }
    } else {
        // 图片loading
        if (typeof show === 'undefined' || show) {
            // 根据要展示的不一样，设置不一样的classname
            if (display === 'inline-block' || display === 'center') {
                result = _react2.default.createElement(
                    'i',
                    getGlobalProps({
                        className: 'icon ico-loading-blue spaui-loading-blue-icon-' + display
                    }),
                    _react2.default.createElement('i', null)
                );
            } else {
                result = _react2.default.createElement(
                    'div',
                    getGlobalProps({
                        className: 'spaui-loading loading-new'
                    }),
                    _react2.default.createElement(
                        'i',
                        { className: 'icon ico-loading-blue' },
                        _react2.default.createElement('i', null)
                    )
                );
            }
        }
    }
    return result;
};